import React, { PureComponent } from 'react'
import { Form, Dropdown, Grid, Button, Modal } from 'semantic-ui-react'

const REFUND_OPTIONS = [
  { key: 'online_payment', text: 'Online Payment', value: 'online_payment' },
  { key: 'gift_card', text: 'Gift Card', value: 'gift_card' },
]
export default class ModalRefund extends PureComponent {
  state = {
    saving: false,
    refundNote: '',
    refundTo: REFUND_OPTIONS[0].value
  }

  componentDidMount() {
    const { order } = this.props

    return { refundTo: order.refund_to || REFUND_OPTIONS[0].value }
  }

  onDropdownChange = (e, data) => this.setState({ refundTo: data.value })

  onRefundNoteChange = e =>  this.setState({ refundNote: e.target.value })

  handleOnSavingClick = async () => {
    try {
      const { order, onSave, onSaveSuccess } = this.props
      const { refundTo, refundNote } = this.state

      this.setState({ saving: true })

      await onSave(order, refundTo, refundNote)

      if (onSaveSuccess) onSaveSuccess()

      this.setState({ saving: false })
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
  }

  render() {
    const { visible } = this.props
    const { saving } = this.state

    return (
      <Modal
        open={visible}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{ marginTop: 0, width: 600 }}
      >
        <Modal.Header>Refund</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Grid columns="equal" style={{ margin: 0 }}>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>
                <Form>
                  <Dropdown
                    fluid
                    selection
                    placeholder='Refund to'
                    options={REFUND_OPTIONS}
                    onChange={this.onDropdownChange}
                    defaultValue={REFUND_OPTIONS[0].value}
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>
                <Form>
                  <Form.TextArea
                    label='Refund Note'
                    onChange={this.onRefundNoteChange}
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            secondary
            content="Save"
            loading={saving}
            disabled={saving}
            onClick={() => this.handleOnSavingClick()}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/ModalRefund.js